export default {
  title: 'Credenciales del personal',
  form: {
    username: {
      label: 'Usuario',
      placeholder: 'Usuario',
    },
    password: {
      label: 'Contraseña',
      placeholder: 'Contraseña',
    },
    button: {
      title: 'Guardar',
    },
    success: 'Información guardada correctamente.',
  },
};
